module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginCom"
  }, [_c('div', {
    staticClass: "loginWrap"
  }, [_c('div', {
    staticClass: "avatar iconfont icon-touxiang"
  }, [_c('img', {
    attrs: {
      "src": _vm.avatar,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "toggle"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('span', {
    class: {
      active: _vm.tabFlag === 'login'
    },
    on: {
      "click": function($event) {
        _vm.tabFlag = 'login'
      }
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.tabFlag === 'register'
    },
    on: {
      "click": function($event) {
        _vm.tabFlag = 'register'
      }
    }
  }, [_vm._v("注册")])])]), _vm._v(" "), _c('form', {
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loginSubmit($event)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabFlag !== 'resetPassword'),
      expression: "tabFlag !== 'resetPassword'"
    }],
    staticClass: "userName"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userName),
      expression: "userName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入您的邮箱"
    },
    domProps: {
      "value": (_vm.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabFlag !== 'resetPassword'),
      expression: "tabFlag !== 'resetPassword'"
    }],
    staticClass: "userPsw"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userPwd),
      expression: "userPwd"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.userPwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userPwd = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabFlag === 'register'),
      expression: "tabFlag === 'register'"
    }],
    staticClass: "userPsw"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userPwdAngin),
      expression: "userPwdAngin"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请再次确认密码"
    },
    domProps: {
      "value": (_vm.userPwdAngin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userPwdAngin = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabFlag === 'resetPassword'),
      expression: "tabFlag === 'resetPassword'"
    }],
    staticClass: "userName"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.restPwdEmail),
      expression: "restPwdEmail"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入您的邮箱"
    },
    domProps: {
      "value": (_vm.restPwdEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.restPwdEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabFlag === 'login'),
      expression: "tabFlag === 'login'"
    }],
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loginSubmit($event)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.loginStatu) + "\n        ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabFlag === 'register'),
      expression: "tabFlag === 'register'"
    }],
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loginSubmit($event)
      }
    }
  }, [_vm._v("\n          注册\n        ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabFlag === 'resetPassword'),
      expression: "tabFlag === 'resetPassword'"
    }],
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.resetPassword($event)
      }
    }
  }, [_vm._v("\n          重置密码\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabFlag === 'login'),
      expression: "tabFlag === 'login'"
    }],
    staticClass: "resetPassword",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.tabFlag = 'resetPassword'
      }
    }
  }, [_vm._v("\n        忘记密码?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "resetPassword",
    staticStyle: {
      "float": "left",
      "text-align": "left"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.goHome($event)
      }
    }
  }, [_vm._v("\n        返回首页\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-270c8aec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/login/index.vue
// module id = 260
// module chunks = 1